export enum ExchangedItemsStatusCode {
  NOSTOCK = 21,
  NOSTOCKBUTCONTACTED = 22,
  NOTHING = 10,
  RECEIVED = 20,
  ALREADYCONTACTED = 30,
  CANCELLEDNOTICKET = 31,
  RECEIVEDANDDELIVERED = 40,
  RETURNED = 50,
  CANCELLEDWITHTICKET = 60
}
